export default __webpack_public_path__ + "static/media/land.06c6a4a5.jpg";